import React from "react";
import { Card } from "@/components/ui/Card";
import { reviewCategories } from "../../constants/reviewCategories";

const SubmittedFeedbackView = ({ data }) => {
  return (
    <div className="space-y-3 mb-6">

      {/* Score banner */}
      <Card className="p-4 rounded-xl bg-emerald-500/10 border border-emerald-500/20">
        <h2 className="text-sm font-semibold text-emerald-500">Feedback Submitted</h2>
        <p className="mt-1 text-xs text-text-primary">Total Score: {data.feedback_score}/10</p>
      </Card>

      {/* Category cards */}
      {reviewCategories.map((category) => {
        const rating = data.feedback_categories?.[category.key] || 0;
        const review = data.category_reviews?.[category.key]    || "";
        const Icon   = category.icon;

        return (
          <Card key={category.id} className="p-4 rounded-xl bg-background-secondary border border-border-primary shadow-sm">
            <div className="space-y-3">

              {/* Header */}
              <div className="flex items-start gap-3">
                <div className="p-1.5 w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-500/10 flex items-center justify-center border border-blue-100 dark:border-blue-500/20 flex-shrink-0">
                  <Icon className="w-3.5 h-3.5 text-blue-500" />
                </div>
                <div>
                  <h3 className="text-text-primary text-sm font-semibold leading-snug">{category.title}</h3>
                  <p className="text-text-secondary text-xs mt-0.5">{category.description}</p>
                </div>
              </div>

              {/* Readonly rating */}
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((num) => (
                  <div
                    key={num}
                    className={`w-8 h-8 rounded-full border flex items-center justify-center text-xs font-medium
                      ${rating === num
                        ? "bg-blue-500 text-white border-blue-500 shadow-sm"
                        : "border-border-primary text-text-muted bg-background-primary"
                      }`}
                  >
                    {num}
                  </div>
                ))}
              </div>

              {/* Readonly review */}
              <div>
                <h2 className="mb-1.5 text-xs font-medium text-text-primary">Written Review</h2>
                <div className="text-xs rounded-lg border border-border-primary px-3 py-2.5 text-text-primary bg-background-primary leading-relaxed">
                  {review || "No review provided"}
                </div>
              </div>
            </div>
          </Card>
        );
      })}

      {/* Additional notes */}
      <Card className="p-4 rounded-xl bg-background-secondary border border-border-primary shadow-sm">
        <h2 className="mb-1.5 text-xs font-medium text-text-primary">Additional Notes</h2>
        <div className="text-xs rounded-lg border border-border-primary px-3 py-2.5 text-text-primary bg-background-primary leading-relaxed">
          {data.feedback_notes || "No additional notes"}
        </div>
      </Card>
    </div>
  );
};

export default SubmittedFeedbackView;